module.exports = __webpack_public_path__ + "img/Icon-Supplements.975448bb.svg";